import logo from './img/DenyDenounceDefend.jpg';
import map from './img/la-protest-map.png';
import './App.css';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Button } from '@mui/material';

const Home = () => {
  return (
    <header className="App-header">
      <h2 className="header">
        End 286 NOW
      </h2>
      <img src={logo} className="App-logo" alt="logo"/>
    </header> 
  )
}

const InProgress = () => {
  return (
    <div className="App-header">
      <p>[In Progress]</p>
    </div>
  )
}

const GetInvolved = () => {
  return (
    <header className="App-header">
      <a className="discordLink" href="https://discord.gg/TDVX2Eaw2x">Join the Discord</a>
    </header>
  )
}

const About = () => {
  return (
    <header className="App-header">
      <h2>Mission Statement</h2>
      <p>To reform the for profit healthcare industry, end 286 denials and obtain free healthcare for ALL Americans.
      </p>
      <h2>About</h2>
      <p>Our group’s purpose is for insurance denial code 286 to be disposed of entirely, spread awareness about the inner workings of the healthcare system and how it impacts the lives of Americans. We came together as a result of the assassination of the UnitedHealthcare CEO to peacefully and effectively organize for change. We support the complete reform of our healthcare industry and seek to change our for profit system via activism, policy changes, and working hand in hand with political leaders to create lasting change that benefits all Americans and ensures that no more lives are lost due to 286 denials.</p>
    </header>
  )
}

const Dates = () => {
  return (
    <header className="App-header">
      <ul>
        <li>January 18th - Protest in D.C. at the <a href="https://www.womensmarch.com/">People's March</a></li>
        <li>January 18th - <a href="/la-protest">Protest in L.A.</a></li>
      </ul>
    </header>
  )
}

const LaProtest = () => {
  return (
    <header className='App-header'>
      <p>Join us on 1/18 in Los Angeles as 286 marches for free healthcare and human rights for all Americans. The state of the country signals that the stakes are even higher and we must ensure that our voices are heard. Due to our closely aligned values, we are doing this under the “The People’s March” umbrella, and distinguishing ourselves with our focus being on free healthcare for all. </p>
      <p>Map</p>
      <img src={map} className="App-logo"/>
      <p>March Start: 10:30 am Pershing Square</p>
      <p>March End: Los Angeles City Hall </p>
      <p>Public Transport: There is a Metro Station in the map above, it is 1 minute walking from the place the march begins. If you can take the Metro, this is a great option so you don’t have to pay for parking. Please see the link for fares: <a href="https://www.metro.net/riding/fares/">https://www.metro.net/riding/fares/</a></p>
      <p>Parking: There are parking lots all around the location that the march begins, however, some have really bad reviews so park at your own risk and ensure you lock your car and don’t leave valuables in your vehicle. We have tagged the closest parking lots with best reviews for you to pick from. Paragon Parking lot seems to have the best reviews and decent rates. </p>

      <p>Meet Up Spot: Paragon Parking Lot</p>
      <p>Time: 10 am </p>
      <p>While there is a parking structure in Pershing Square, we anticipate that the parking lot will fill up quickly.  We have chosen a parking lot close by, 0.2 miles from the start of the march. We will meet at Paragon Parking lot to get our signs together, distribute snacks/ water and review our safety protocols 30 minutes before the march begins. Please be there at 10 am sharp. </p>
      <p>Safety: WHAT TO DO</p>
      <ul>
        <li>Plan ahead! Know your essential care needs and supplies. Know how to get assistance. Plan for how to re-connect with your friends if separated</li>
        <li>Be calm and focused.</li>
        <li>When things get intense, react to warning signs sooner, not later.</li>
        <li>Watch for signs of physical or mental concerns in yourself and others. Cool down others who exhibit panic behavior. Non-violence is the way to go!</li>
        <li>Document or write down police actions, brutality and injuries. Don't engage</li>
      </ul>
      <p>WHAT NOT TO DO</p>
      <ul>
        <li>Don't go alone if you can help it - go with an affinity group or some friends</li>
        <li>Don't forget to eat food and drink lots of water! Hydrate, Hydrate, Hydrate!</li>
        <li>Don't wear things that can be easily grabbed (i.e jewelry, loose hair etc)</li>
        <li>Don't neglect face and skin protection (i.e goggles, face masks etc)</li>
      </ul>
      <p>WHAT TO BRING</p>
      <ul>
        <li>Water in a plastic bottle with squirt top. Use to drink and wash skin/face/eyes</li>
        <li>Energy snacks!</li>
        <li>Enough money (cash) for pay-phone, food, transportation
        </li>
        <li>Emergency contact information</li>
        <li>Basic First Aid Kit & individual medical needs (i.e inhaler, api-pen, insulin etc)</li>
        <li>Wet wipes, tissues and mentstrual needs if applicable</li>

      </ul>
      <p>WHAT TO WEAR</p>
      <ul>
        <li>Comfortable, protective shoes that you can run in</li>
        <li>Clothing covering all your skin to protect from sun and other exposures</li>
        <li>Hat to protect your face and hair from sun and other exposures</li>
        <li>Keep a fresh change of clothes in your backpack in case of contamination</li>
        <li>Face covering (i.e bandana, mask etc)</li>
        <li>Eye covering (i.e goggles, shatter-proof glasses)</li>
      </ul>

      <p>DEALING WITH TEAR GAS</p>
      <p>WE DO NOT CONDONE VIOLENCE - IN THE EVENT OF VIOLENCE PLEASE SEEK IMMEDIATE SAFETY</p>
      <ul>
        <li>STAY CALM. Panicking increases the irritation. Breathe and slow down</li>
        <li>Avoid use of oils & lotions. They trap chemicals and prolong exposure</li>
        <li>Blow your nose, rinse your mouth, cough & spit. Try not to swallow.</li>
        <li>DO NOT RUB IT IN!</li>
        <li>Contact wearers: remove lenses and replace with clean ones. Destroy exposed ones</li>
        <li>Use an eye flush immediately after exposure</li>
      </ul>
      <p>KNOW YOUR RIGHTS</p>
      <ul>
        <li>Freedom of Expression and Assembly: Everyone has the right to carry their opinion to the streets</li>
        <li>Protection of the Right to Freedom of Assembly: Law enforcement must facilitate and not restrict a peaceful public assembly</li>
        <li>Freedom from excessive use of force: In the policing of non-violent protests, police must avoid the use of force</li>
        <li>Right to Medical Assistance: If you are injured, you have a right to medical assistance without delay
        </li>
        <li>Freedom from Arbitrary Arrest and Detention: You have the right to be told the reason for your arrest and the right to have access to a lawyer and family</li>
        <li>Right to Complain: If your rights have been violated, you have a right to file a complaint and to be provided information on how to do so.</li>
      </ul>
    </header>
  )
}

const Main = () => {
  return (
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/dates' element={<Dates />}></Route>
        <Route path='/who-we-are' element={<About />}></Route>
        <Route path='/get-involved' element={<GetInvolved />}></Route>
        <Route path='/resources' element={<InProgress />}></Route>
        <Route path='/la-protest' element={<LaProtest />}></Route>
      </Routes>
  )
}

const Nav = () => {
  return (
    <Box sx={{ flexGrow: 1}}>
          <AppBar sx={{bgcolor: 'black'}}>
            <Toolbar sx={{justifyContent: 'center', display: 'flex', flexWrap: 'wrap'}}>
              <NavLink to='/' className="link" end>Home</NavLink>
              <NavLink to='/who-we-are' className="link" end>Who We Are</NavLink>
              <NavLink to='/dates' className="link">Dates</NavLink>
              <NavLink to='/get-involved' className="link">Get Involved</NavLink>
              <NavLink to='/resources' className="link">Resources</NavLink>
              {/* <Button>Donate</Button> */}
            </Toolbar>
          </AppBar>
        </Box> 
  )
}

function App() {
  return (
      <div className="main-center">
        <BrowserRouter>
          <Nav />
          <div className="mainWrapper">
            <Main />
          </div>
        </BrowserRouter>
      </div>
  );
}

export default App;
